import { Injectable, signal, computed } from '@angular/core';

export interface Notification {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message?: string;
  duration?: number;
  timestamp: number;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private _notifications = signal<Notification[]>([]);
  notifications = this._notifications.asReadonly();

  unreadCount = computed(() => this._notifications().length);

  show(
    type: Notification['type'],
    title: string,
    message?: string,
    duration = 4000
  ): void {
    const id = crypto.randomUUID();
    const n: Notification = { id, type, title, message, duration, timestamp: Date.now() };
    this._notifications.update((list) => [n, ...list].slice(0, 8));

    if (duration > 0) {
      setTimeout(() => this.dismiss(id), duration);
    }
  }

  success(title: string, message?: string) {
    this.show('success', title, message);
  }

  error(title: string, message?: string) {
    this.show('error', title, message, 6000);
  }

  warning(title: string, message?: string) {
    this.show('warning', title, message);
  }

  info(title: string, message?: string) {
    this.show('info', title, message);
  }

  dismiss(id: string): void {
    this._notifications.update((list) => list.filter((n) => n.id !== id));
  }

  dismissAll(): void {
    this._notifications.set([]);
  }
}
